// Module
var code = "<div class=\"vtform__body\" data-ng-style=\"{ 'height': fb.height(), 'top': fb.top() }\">\n    <div data-ng-transclude></div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/form/vt-form-body.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;